import { GetterTree } from "vuex";
import { NotificationsState } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<NotificationsState, RootState> = {
  notifications: (state) => state.notifications,
  dashboardNotifications: (state) =>
    state.notifications.filter((notification) => notification.isDashboard),
};
